export const inner_route_spacetags_all_workspace = "/corporate/spacetags/workspace";
export const inner_route_spacetags_workspace_calender = "/corporate/spacetags/workspace/calender";
export const inner_route_spacetags_workspace_calender_slots = "/corporate/spacetags/workspace/calender/slots";
export const inner_route_spacetags_workspace_create = "/corporate/spacetags/workspace/create";
